import React from 'react';
import {connect} from 'react-redux';
import Modal from '../components/Modal';
import StaffMemberPicker from '../components/StaffMemberPicker';
import {updateUsersAssignedToClient} from '../actions/ClientActions';

@connect(
    state => ({
        isAssigningUserToClient: state.modal.isAssigningUserToClient
    }),
    { updateUsersAssignedToClient }
)
export default class AssignStaffMemberToClientModal extends React.Component {
    static defaultProps = { onlyOneAssign: false };
    constructor(props) {
        super(props);
        this.state = {assignedUserIds: props.client.assignedUserIds};
    }
    saveAssignedUsers() {
        this.props.updateUsersAssignedToClient(this.props.client.id, this.state.assignedUserIds);
    }
    render() {
        var actionButton = this.props.isAssigningUserToClient ?
            (<button className="btn btn-success disabled">Saving...</button>) :
            (<button className="btn btn-success" onClick={this.saveAssignedUsers.bind(this)}>Save</button>);

        var editText = this.props.onlyOneAssign ? "Edit user assigned to" : "Edit users assigned to";

        return (
            <Modal actionButton={actionButton} className="modal-success"  title={`${editText} ${this.props.client.name}`}>
                <StaffMemberPicker
                    onSelectChange={assignedUserIds => this.setState({assignedUserIds})}
                    onlyOneAssign={this.props.onlyOneAssign}
                    assignedUserIds={this.state.assignedUserIds} />
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/AssignStaffMemberToClientModal.js